import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import * as React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Avatar } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import { createTheme, useTheme } from '@mui/material/styles';
import { ThemeProvider } from '@mui/material';
const drawerWidth = 0;
export const TOP_MARGIN = 64;
const EditorLayout = ({ children, data, maxWidth, useStorageUrl }) => {
    let top_bar_menu = undefined;
    let bottom_menu = undefined;
    let editorMaxWidth = maxWidth ? maxWidth : 1280;
    let usedStorageUrl = useStorageUrl ? useStorageUrl : false;
    const default_theme = useTheme();
    const base_theme = createTheme({
        palette: {
            primary: {
                light: default_theme.palette.primary.light,
                main: data.page_layout_data.item_background ? data.page_layout_data.item_background : default_theme.palette.primary.main,
                dark: data.page_layout_data.item_hover_color ? data.page_layout_data.item_hover_color : default_theme.palette.primary.dark,
                contrastText: data.page_layout_data.text_color ? data.page_layout_data.text_color : default_theme.palette.primary.contrastText,
            }
        },
    });
    const base_hover_text_color = data.page_layout_data.item_hover_text_color;
    function create_sub_menu_item(menu_item, isRight, handleCloseNavMenu) {
        if (menu_item.right != isRight) {
            return (React.createElement(React.Fragment, null));
        }
        return (React.createElement(MenuItem, { key: menu_item, component: Link, onClick: handleCloseNavMenu, href: menu_item.url, target: menu_item.open_in_new_tab ? "_blank" : undefined },
            React.createElement(Typography, { textAlign: "center" }, menu_item.label)));
    }
    function create_menu_item(menu_item, isRight, menu_theme, menu_hover_color, menu_is_hower_shadow) {
        if (menu_item.right != isRight) {
            return (React.createElement(React.Fragment, null));
        }
        let icon = menu_item.icon;
        if (usedStorageUrl && menu_item.icon_content_hash) {
            icon = menu_item.icon_content_hash;
        }
        const menu_item_color = menu_item.text_color;
        const menu_item_backgroundColor = menu_item.backgound_color;
        const menu_item_hoverBackgroundColor = menu_item.hover_backgound_color;
        const menu_item_theme = createTheme(menu_theme, {
            palette: {
                primary: {
                    main: menu_item_backgroundColor ? menu_item_backgroundColor : menu_theme.palette.primary.main,
                    dark: menu_item_hoverBackgroundColor ? menu_item_hoverBackgroundColor : menu_theme.palette.primary.dark,
                    contrastText: menu_item_color ? menu_item_color : menu_theme.palette.primary.contrastText,
                }
            },
        });
        let style = {
            marginLeft: 'auto',
            border: 'none',
            outline: 'none',
            boxShadow: 'none',
            '&:hover': {}
        };
        if (!menu_is_hower_shadow && !menu_item.hover_shadow) {
            style['&:hover'] = Object.assign(Object.assign({}, style['&:hover']), { boxShadow: 'none' });
        }
        if (menu_item.hover_text_color || menu_hover_color || base_hover_text_color) {
            let item_hover_color = base_hover_text_color ? base_hover_text_color : menu_hover_color;
            item_hover_color = menu_item.hover_text_color ? menu_item.hover_text_color : item_hover_color;
            style['&:hover'] = Object.assign(Object.assign({}, style['&:hover']), { color: item_hover_color });
        }
        return (React.createElement(ThemeProvider, { theme: menu_item_theme },
            React.createElement(Button, { variant: 'contained', href: menu_item.url, target: menu_item.open_in_new_tab ? "_blank" : undefined, color: "primary", "aria-label": "open drawer", sx: style, startIcon: icon ? React.createElement(Avatar, { src: icon }) : undefined }, menu_item.label)));
    }
    function create_menu_items(menu_items, isRight, menu_theme, menu_hover_color, menu_is_hower_shadow) {
        let style = !isRight ? { flexGrow: 1, display: 'flex', marginLeft: '5px' } : { flexGrow: 1, display: { xs: 'none', lg: 'flex' }, justifyContent: 'flex-end', marginRight: '5px' };
        return (React.createElement(Box, { sx: style }, menu_items.map((menu_item, index) => {
            var _a;
            return (React.createElement("div", { key: (_a = menu_item.label) !== null && _a !== void 0 ? _a : index }, create_menu_item(menu_item, isRight, menu_theme, menu_hover_color, menu_is_hower_shadow)));
        })));
    }
    function create_sub_menu(menu_items, isRight, menu_id) {
        const [anchorElNav, setAnchorElNav] = React.useState(null);
        const handleOpenNavMenu = (event) => {
            setAnchorElNav(event.currentTarget);
        };
        const handleCloseNavMenu = () => {
            setAnchorElNav(null);
        };
        return (React.createElement(Box, { sx: { flexGrow: 1, display: { xs: 'flex', lg: 'none', }, justifyContent: 'flex-end' } },
            React.createElement(IconButton, { size: "large", "aria-label": "menu open", "aria-controls": menu_id, "aria-haspopup": "true", onClick: handleOpenNavMenu, color: "inherit" },
                React.createElement(MenuIcon, null)),
            React.createElement(Menu, { id: menu_id, anchorEl: anchorElNav, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                }, keepMounted: true, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                }, open: Boolean(anchorElNav), onClose: handleCloseNavMenu, sx: {
                    display: { xs: 'block', lg: 'none' },
                } }, menu_items.map((menu_item) => (React.createElement(React.Fragment, null, create_sub_menu_item(menu_item, isRight, handleCloseNavMenu)))))));
    }
    function create_menu(menu, base_theme, top_position) {
        const color = menu.text_color;
        const backgroundColor = menu.backgound_color;
        const hoverBackgroundColor = menu.hover_backgound_color;
        const menu_theme = createTheme(base_theme, {
            palette: {
                primary: {
                    main: backgroundColor ? backgroundColor : base_theme.palette.primary.main,
                    dark: hoverBackgroundColor ? hoverBackgroundColor : base_theme.palette.primary.dark,
                    contrastText: color ? color : base_theme.palette.primary.contrastText,
                }
            },
            typography: {
                button: {
                    fontSize: top_position ? '1.25rem' : '0.8rem',
                },
            },
        });
        const menu_hover_color = menu.hover_text_color;
        const menu_is_hower_shadow = menu.hover_shadow;
        let menu_left_items = create_menu_items(menu.menu_items, false, menu_theme, menu_hover_color, menu_is_hower_shadow);
        let menu_right_items = create_menu_items(menu.menu_items, true, menu_theme, menu_hover_color, menu_is_hower_shadow);
        let sub_menu = create_sub_menu(menu.menu_items, true, top_position ? "top-menu" : "bottom-menu");
        return (React.createElement(ThemeProvider, { theme: menu_theme },
            React.createElement(AppBar, { position: top_position ? "fixed" : "relative", sx: {
                    width: { sm: '100%' },
                    ml: { sm: top_position ? "100%" : 0 },
                } },
                React.createElement(Toolbar, { sx: {
                        margin: "auto",
                        maxWidth: editorMaxWidth,
                        width: "100%"
                    }, disableGutters: true },
                    menu_left_items && (React.createElement(React.Fragment, null, menu_left_items)),
                    menu_right_items && (React.createElement(React.Fragment, null, menu_right_items)),
                    sub_menu && (React.createElement(React.Fragment, null, sub_menu))))));
    }
    if (data) {
        if (data.page_layout_data && data.show_menu) {
            if (data.page_layout_data.top_menu) {
                top_bar_menu = create_menu(data.page_layout_data.top_menu, base_theme, true);
            }
            if (data.page_layout_data.bottom_menu) {
                bottom_menu = create_menu(data.page_layout_data.bottom_menu, base_theme, false);
            }
        }
    }
    return (React.createElement(ThemeProvider, { theme: base_theme },
        React.createElement(CssBaseline, null),
        React.createElement(Box, null,
            top_bar_menu && (React.createElement(React.Fragment, null, top_bar_menu)),
            React.createElement(Box, { component: "main", sx: {
                    flexGrow: 1,
                    margin: 'auto',
                    marginTop: TOP_MARGIN.toString() + 'px',
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    backgroundColor: data.page_layout_data.background_color ? data.page_layout_data.background_color : "white",
                    color: data.page_layout_data.text_color ? data.page_layout_data.text_color : '#333333',
                } },
                React.createElement(Box, { sx: {
                        flexGrow: 1,
                        backgroundColor: data.page_layout_data.content_background_color ? data.page_layout_data.content_background_color : 'white',
                        maxWidth: editorMaxWidth,
                        margin: 'auto',
                    } }, children)),
            React.createElement("footer", null, bottom_menu && (React.createElement(React.Fragment, null, bottom_menu))))));
};
export default EditorLayout;
//# sourceMappingURL=EditorLayout.js.map